// extracted by mini-css-extract-plugin
export default {"filterTags":"rfBzzZ29BnjLALcRW3ShBQ=="};